import React, { Component } from 'react'
import { Box, createStyles, Theme, Typography, withStyles, WithStyles } from '@material-ui/core'
import * as PackageJson from '../../../package.json'

const VERSION = PackageJson.version

const Style = (theme: Theme) => createStyles({
    footer: {
        textAlign: 'center',
        flexShrink: 0,
        padding: theme.spacing(2)
    },
    textColor: {
        color: theme.palette.text.primary
    }
})

interface Props {
    className?: string
}

type IProps = Props & WithStyles<typeof Style>

class Footer extends Component<IProps> {
    public render() {
        const { classes, className } = this.props
        const year = new Date().getFullYear()
        const appTitle: string = `${process.env.REACT_APP_WEB_APP_TITLE}`
        return <footer className={classes.footer}>
            <Box className={className}>
                <Typography variant="caption">
                    <b>© {year} {appTitle} <small>v{VERSION}</small></b>
                </Typography>
            </Box>
        </footer>
    }
}

export default withStyles<any>(Style)(Footer)
